export enum FeatureHealthProviderName {
  WEBHOOK = 'Webhook',
  GRAFANA = 'Grafana',
}
